/* ── compact presentational stat card (flex, no grid) ─────────────────────── */
export default function StatCard({
  label,
  value,
  color,
  icon,
}: {
  label: string;
  value: number;
  color: string;
  icon: React.ReactNode;
}) {
  return (
    <div
      className="organisation-card"
      style={{
        flex: "1 1 240px",
        minWidth: 240,
        height: 92,
        padding: "0 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderLeft: `4px solid ${color}`,
      }}
    >
      <div>
        <div style={{ fontSize: 13.5, color: "var(--ctpl-ink-soft)" }}>{label}</div>
        <div style={{ fontSize: 26, fontWeight: 700, color, lineHeight: 1.2, marginTop: 2 }}>
          {value}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 46,
          height: 46,
          borderRadius: "50%",
          background: `${color}1A`,
          flexShrink: 0,
        }}
      >
        {icon}
      </div>
    </div>
  );
}